import {BrowserRouter as Router, Routes, Route} from "react-router-dom";
import Dashboard from "./pages/dashboard";
import RecordsByDate from "./pages/recordsByDate";
import AccountBalances from "./pages/accountBalances";
import {DateProvider} from "./contexts/DateContext";

function App() {

    return (
        <DateProvider>
            <Router>
                <div className="App">
                    <Routes>
                        <Route path="/" element={<Dashboard/>}/>
                        <Route path="/logs" element={<RecordsByDate/>}/>
                        <Route path="/account-balances" element={<AccountBalances/>}/>
                    </Routes>
                </div>
            </Router>
        </DateProvider>
    );
}

export default App;
